import React from 'react';

import { VerificationRequestProcessingContext } from 'src/providers/VerificationRequestProcessingProvider';

export const useVerificationRequestProcessing = () => {
  return React.use(VerificationRequestProcessingContext);
};
